import React, { FC } from 'react'

import './Skeleton.scss'

const SkeletonArtistInfo: FC = () => (
  <div className="pd-skeleton__flex">
    <div className="pd-skeleton__avatar pd-skeleton__avatar--big" />
    <div className="pd-skeleton__line pd-skeleton__title" />
  </div>
)

export default SkeletonArtistInfo
